import { sanitizeData } from './encryption';

export const validatePassword = (password: string): { isValid: boolean; message: string } => {
  const sanitizedPassword = sanitizeData(password);
  
  if (!sanitizedPassword) {
    return { isValid: false, message: 'Password is required' };
  }

  if (sanitizedPassword.length < 8) {
    return { isValid: false, message: 'Password must be at least 8 characters long' };
  }

  // Require at least one uppercase letter
  if (!/[A-Z]/.test(sanitizedPassword)) {
    return { isValid: false, message: 'Password must contain at least one uppercase letter' };
  }

  // Require at least one lowercase letter
  if (!/[a-z]/.test(sanitizedPassword)) {
    return { isValid: false, message: 'Password must contain at least one lowercase letter' };
  }

  // Require at least one number
  if (!/\d/.test(sanitizedPassword)) {
    return { isValid: false, message: 'Password must contain at least one number' };
  }

  // Require at least one special character
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(sanitizedPassword)) {
    return { isValid: false, message: 'Password must contain at least one special character' };
  }

  // Check for common patterns
  const commonPatterns = [
    /^password/i,
    /^12345/,
    /^qwerty/i,
    /^admin/i,
    /^letmein/i,
    /^welcome/i
  ];

  if (commonPatterns.some(pattern => pattern.test(sanitizedPassword))) {
    return { isValid: false, message: 'Please choose a less common password' };
  }

  return { isValid: true, message: '' };
};

export const validateEmail = (email: string): { isValid: boolean; message: string } => {
  const sanitizedEmail = sanitizeData(email);
  
  if (!sanitizedEmail) {
    return { isValid: false, message: 'Email is required' };
  }

  // Enhanced email regex that checks for valid email format
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(sanitizedEmail)) {
    return { isValid: false, message: 'Please enter a valid email address' };
  }

  // Check for common disposable email domains
  const disposableDomains = [
    'tempmail.com',
    'throwawaymail.com',
    'mailinator.com',
    'guerrillamail.com',
    'sharklasers.com',
    'spam4.me',
    'yopmail.com'
  ];
  
  const domain = sanitizedEmail.split('@')[1].toLowerCase();
  if (disposableDomains.includes(domain)) {
    return { isValid: false, message: 'Please use a permanent email address' };
  }

  return { isValid: true, message: '' };
};